import React from 'react';
import { Stack } from '@grubhubprod/gh-cookbook-react';
import { get } from '@grubhubprod/umami-library/dist/nodash/get';
import { FeeLineItem } from 'src/components/selfService/features/OrderHistory/FeeLineItem/FeeLineItem';
import { ReceiptLineItem } from 'src/components/selfService/features/OrderHistory/ReceiptLineItem/ReceiptLineItem';
import {
  calculateDeliveryFee,
  getCampaignDeliveryFeeDisplayText,
} from 'src/components/selfService/features/OrderHistory/OrderReceipt.utils';
import { FeeType, IOrderPayment, IOrdersReceipt } from 'src/types/OrderHistory';

interface DeliveryFeeSectionProps {
  order: IOrdersReceipt;
  grubhubPlusPayment?: IOrderPayment;
}

export function DeliveryFeeSection({
  order,
  grubhubPlusPayment,
}: DeliveryFeeSectionProps): JSX.Element {
  const campaignDeliveryFee = getCampaignDeliveryFeeDisplayText(order);

  if (campaignDeliveryFee) {
    return (
      <Stack y="sm">
        <FeeLineItem
          order={order}
          feeAmount={calculateDeliveryFee(order)}
          campaignFeeType={FeeType.DELIVERY}
          title="Delivery fee"
        />
      </Stack>
    );
  }

  if (grubhubPlusPayment) {
    return (
      <Stack y="sm">
        <ReceiptLineItem
          title={
            get(grubhubPlusPayment, 'metadata', 'subscription_cobrand') ||
            'Grubhub+'
          }
          amount="Free delivery"
          color="success"
        />
      </Stack>
    );
  }

  return (
    <Stack y="sm">
      <FeeLineItem
        order={order}
        feeAmount={calculateDeliveryFee(order)}
        campaignFeeType={FeeType.DELIVERY}
        title="Delivery fee"
      />
    </Stack>
  );
}
